module.exports = __webpack_public_path__ + "img/aks.f30a4ee5.svg";